import React, { useState } from "react";
import queryString from "query-string";
import Dropdown from ".";
import { ApiUserMinimal } from "src/api/types";
import useGet from "src/hooks/rest/useGet";
import MultiSelectList from "src/components/form/Dropdown/MultiSelectList";
import { useTranslation } from "react-i18next";

interface ConnectionDropdownProps {
	label?: string;
	placeholder?: string;
	onChange: (value?: number | string | any[]) => void;
	value?: number | any[];
	exclude?: any[];
	variant: "dropdown" | "list";
}

const ConnectionDropdown = ({
	onChange,
	label,
	placeholder,
	value,
	exclude,
	variant,
}: ConnectionDropdownProps) => {
	const { t } = useTranslation("form", { keyPrefix: "connection-dropdown" });
	const [search, setSearch] = useState("");
	const q = queryString.stringify({
		q: search,
		sort: "popular",
		"exclude[]": exclude,
		limit: 6,
	});
	const [{ data, meta }, loading, { fetchNext }] = useGet(
		`/connections?${q}`
	);
	const options = (data || []).map((item: ApiUserMinimal) => ({
		id: item.hid,
		name: item.full_name,
		avatar: item.avatar,
		rating: Number(item.reviews?.rating),
	}));

	if (variant === "list") {
		if (!search && !data?.length && !loading) {
			return (
				<div className="flex flex-col px-4 mt-8 justify-center items-center">
					<strong className="mb-1">{t("empty.title")}</strong>
					<p className="mb-0">{t("empty.description")}</p>
				</div>
			);
		}

		return (
			<MultiSelectList
				value={Array.isArray(value) ? value : []}
				button={{
					label: t("load-more"),
				}}
				settings={{
					showAvatar: true,
					showRating: true,
				}}
				search={{
					value: search,
					onChange: setSearch,
					placeholder,
				}}
				hasMore={meta?.current_page !== meta?.last_page}
				onNext={fetchNext}
				{...{ options, onChange, loading }}
			/>
		);
	}

	return (
		<Dropdown
			hasAvatar
			onSearch={(q) => setSearch(q)}
			value={!Array.isArray(value) ? value : undefined}
			{...{ onChange, loading, placeholder, options, label }}
		/>
	);
};

ConnectionDropdown.defaultProps = {
	variant: "dropdown",
};

export default ConnectionDropdown;
